exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttonText {\n  margin-top: 12px;\n  margin-bottom: 12px;\n  color: white;\n  width: 44%;\n  font-size: 16px;\n  line-height: 18px;\n  font-weight: bold;\n  border: none; }\n\n.softFoneOverlay {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.5);\n  transition: opacity 500ms;\n  opacity: 1;\n  z-index: 9999; }\n\n.softFonePopup {\n  position: absolute;\n  margin: auto;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 350px;\n  height: 150px;\n  cursor: pointer; }\n\n.softFonePopup .close {\n  position: absolute;\n  top: 5px;\n  right: 10px;\n  transition: all 200ms;\n  font-size: 30px;\n  font-weight: bold;\n  text-decoration: none;\n  color: white;\n  opacity: 1; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/src/app/footer/footer.component.scss
// module id = ../../../../../src/app/footer/footer.component.scss
// module chunks = 1